module.exports = __webpack_public_path__ + "static/media/sra465f60408d52296268945ad7a5b6e62.webp";